import { createSelector } from "reselect"
import { DEFAULT_CABIN_CLASS_TYPE } from "@kiwicom/frontend-common/records/CabinClass"
import { isDarwinFeatureOn } from "@kiwicom/frontend-common/services/abTesting/darwinHelper"

const formSelector = (state) => state.plainSearchForm.form

const altFlightsSelector = (state) => state.alternativeFlights.flights
const altLoadingSelector = (state) => state.alternativeFlights.loading

const alternativesSelector = (state) => state.changeFlights.alternatives
const initiatorApiSelector = (state) => state.changeFlights.initiatorApi
const changeFlightFormSelector = (state) => state.changeFlights.form

export const errorSelector = (state) => state.alternativeFlights.error

export const searchIdWithFiltersSelector = createSelector(
  [formSelector, changeFlightFormSelector],
  (alternativeFlightForm, { fields: filters }) =>
    [
      alternativeFlightForm.getSearchId(),
      filters.sort,
      filters.cabinType || DEFAULT_CABIN_CLASS_TYPE,
      filters.transportTypes,
      filters.maxTravelDuration,
      filters.cabinTypeMixedAllowed,
    ].join("|"),
)

export const flightsSelector = createSelector(
  [searchIdWithFiltersSelector, altFlightsSelector, alternativesSelector, initiatorApiSelector],
  (searchId, flights, alternatives, initiatorApi) => {
    if (initiatorApi) {
      return alternatives
    }
    return flights.get(searchId)
  },
)

export const refreshSelector = createSelector(
  [searchIdWithFiltersSelector, altFlightsSelector, altLoadingSelector, errorSelector],
  (searchId, flights, loading, error) => !error && !loading.get(searchId) && !flights.get(searchId),
)

export const loadingSelector = createSelector([altLoadingSelector], (loading) =>
  loading.valueSeq().includes(true),
)

/**
 * As soon as there is a single search made, we want to show the results page.
 */
export const shouldShowAlternativeResultsSelector = createSelector(
  [altLoadingSelector, alternativesSelector, initiatorApiSelector],
  (loading, alternatives, initiatorApi) =>
    (initiatorApi ? alternatives.size > 0 : loading.size > 0) ||
    isDarwinFeatureOn("MANUAL_FLIGHT_CHANGE"),
)
